import { Component, OnInit } from '@angular/core';
import { IWidgetEditor, WidgetType, ClockWidget } from "src/app/models/dashboard";
import { Dashboard } from 'src/api/models'

@Component({
  selector: 'clock-widget-editor',
  templateUrl: './clock-widget-editor.component.html',
  styleUrls: ['./clock-widget-editor.component.css']
})
export class ClockWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: ClockWidget;
  public dashboard: Dashboard;

  constructor() {
  }

  ngOnInit() {
    this.widget.size = 12;
  }

}
